import type { Release } from '../releases.ts';

export default {
  version: '0.1.0',
  date: '2026-09-28',
  title: 'First release',
  summary: [
    'Upload with resumable chunks, and automatic proxies, thumbnails, scrub images and waveforms',
    'A Library with search and filters, a player and metadata editing',
    'Runs with Docker Compose',
  ],
  features: [
    'Upload with resumable chunks, automatic proxies, thumbnails, scrub images and waveforms',
    'Library with search and filters, asset player and metadata editing',
    'Docker Compose stack and native development runner',
  ],
  fixes: [],
} satisfies Release;
